export const GETBOOK            = "[book] Book";
export const GETBOOK_SUCCESS    = "[book] Book success";
export const GETBOOK_ERROR      = "[book] Book error";
export const SETBOOK            = "[book] Book set";


export const GETBOOKDETAILS                =  "[BookDetails] BOOKDETAILS";
export const GETBOOKDETAILS_SUCCESS        = "[BookDetails] BOOKDETAILS success";
export const GETBOOKDETAILS_ERROR          = "[BookDetails] BOOKDETAILS error";
export const SETBOOKDETAILS                =  "[BookDetails] BOOKDETAILS SET";
export const SETORDERBOOKINGDETAILS         =  "[BOOKINGDETAILS] BOOKBOOKING SET";

export const BOOKPAYMENTPROCESS =  "[Book PAYMENT PROCESS]";
export const BOOKPAYMENTSUCCESS   = "[Book PAYMENT SUCCESS] GET TRANS,SIGN,ORDER";
export const BOOKPAYMENTERROR = "['PAYMENT FAIL']";


export const GETPAYMENT = "[Book PAYMENTDETAILS]";
export const GETPAYMENTERROR =   "[ Book PAYMENTDETAILS ERROR]";
export const GETPAYMENTSUCCESS =   "[ Book PAYMENTDETAILS SUCCESS]";
export const SETPAYMENT =  "[PAYMENTDETAILS SET]";


export const BOOKCOMPLETE = "[BOOK COMPLETE]";
export const BOOKCOMPLETEERROR = "[BOOK COMPLETE ERROR]";
export const BOOKCOMPLETESUCCESS = "[BOOK COMPLETE SUCCESS]";

export const BOOKUSERDETAILS = "[BOOK USER DETAILS]";
export const BOOKUSERDETAILSERROR = "[BOOK USER DETAILS ERROR]";
export const BOOKUSERDETAILSSUCCESS = "[BOOK USER DETAILS SUCCESS]";
export const SETSHIPMENTPAYMENT = "[SET SHIPMENT PAYMENT]";


export const GETTEMPLEDETAILS = "[TEMPLE DETAILS]";
export const GETTEMPLEDETAILS_SUCCESS = "[TEMPLE DETAILS SUCCESS]";
export const GETTEMPLEDETAILS_ERROR = "[TEMPLE DETAILS ERROR]";
export const SETTEMPLEDETAILS = "[SET TEMPLE DETAILS]";






// BOOK LIST

export const getBook = (data) => ({
    type: GETBOOK,
    payload: data
});
export const getBookSuccess = (data) => ({
    type: GETBOOK_SUCCESS,
    payload: data
});

export const getBookError = (data) => ({
    type: GETBOOK_ERROR,
    payload: data
});

export const setBook = (data) => ({
    type: SETBOOK,
    payload: data
});


// BookDetails 


export const getBookdetails = (data) => ({
    type : GETBOOKDETAILS,
    payload : data,
});

export const getBookdetailsSuccess = (data) => ({
    type: GETBOOKDETAILS_SUCCESS,
    payload : data,
});

export const getBookdetailsError  = (data) => ({
    type : GETBOOKDETAILS_ERROR,
    payload : data,
});

export const setBookdetails = (data) => ({
    type : SETBOOKDETAILS,
    payload : data,
});

export const setorderBookingDetails = (data) => ({
    type : SETORDERBOOKINGDETAILS,
    payload : data,
});


export const bookPaymentProcess = (data) => ({
  type : BOOKPAYMENTPROCESS,
  payload : data,
});

export const bookPaymentSuccess = (data) => ({
  type : BOOKPAYMENTSUCCESS,
  payload : data,
});

export const bookPaymentError = (data) => ({
  type : BOOKPAYMENTERROR,
  payload : data,
});

export const getbookpayment = (data) => ({
  type : GETPAYMENT,
  payload : data,
});

export const setBookPaymentDetails = (data) => ({
  type : SETPAYMENT,
  payload : data,
});
 
export const getBookPaymentDetailsError = (data) => ({
type : GETPAYMENTERROR,
payload : data,
});
    
export const getBookPaymentDetailsSuccess = (data) => ({
type : GETPAYMENTSUCCESS,
payload : data,
})

export const bookComplete = (data) => ({
  type : BOOKCOMPLETE,
  payload : data,
});

export const bookCompleteSuccess = (data) => ({
  type : BOOKCOMPLETESUCCESS,
  payload : data,
});

export const bookCompleteError = (data) => ({
  type : BOOKCOMPLETEERROR,
  payload : data,
});

export const booksUserDetails = (data) => ({
  type : BOOKUSERDETAILS,
  payload : data,
});

export const bookUserDetailsSuccess = (data) => ({
  type : BOOKUSERDETAILSSUCCESS,
  payload : data,
});

export const bookUserDetailsError = (data) => ({
  type : BOOKUSERDETAILSERROR,
  payload : data,
});

export const setShippingCharges = (data) => ({
  type : SETSHIPMENTPAYMENT,
  payload : data,
});


export const getTempleDetails = (data) => ({
  type: GETTEMPLEDETAILS,
  payload: data
});
export const getTempleDetailsSuccess = (data) => ({
  type: GETTEMPLEDETAILS_SUCCESS,
  payload: data
});

export const getTempleDetailsError = (data) => ({
  type: GETTEMPLEDETAILS_ERROR,
  payload: data
});

export const setTempleDetails = (data) => ({
  type: SETTEMPLEDETAILS,
  payload: data
});
